import { Box, Grid, Typography, alpha, useTheme } from '@mui/material';

const subheaderSx = { mr: 0.5, fontSize: 11.5, color: 'text.secondary' };

const TicketInfoChip = ({
    label,
    value,
    rawValue = false,
}: {
    label?: string;
    value: string | undefined;
    rawValue?: boolean;
}) => {
    const theme = useTheme();
    const isRawValue = rawValue && Boolean(value);
    const color = isRawValue
        ? theme.palette.mode === 'dark'
            ? theme.palette.primary.light
            : theme.palette.primary.main
        : handleStatusColor(value, theme);
    const chipBackground = alpha(color, 0.1);
    const chipBorder = '1px solid transparent';

    return (
        <Grid item>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {label && <Typography sx={subheaderSx}>{label}:</Typography>}
                <Box
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        px: 1,
                        py: 0.25,
                        borderRadius: 0.75,
                        bgcolor: chipBackground,
                        border: chipBorder,
                    }}>
                    <Box
                        component="span"
                        sx={{
                            width: 7,
                            height: 7,
                            flexShrink: 0,
                            borderRadius: '50%',
                            bgcolor: color,
                        }}
                    />
                    <Typography
                        variant="body2"
                        sx={{
                            color,
                            lineHeight: 1.5,
                            fontSize: 12,
                            fontWeight: 500,
                            whiteSpace: 'nowrap',
                        }}
                        style={{ marginRight: '6px', marginLeft: 0 }}>
                        {value ? (rawValue ? value : handleStatusLabel(value)) : '-'}
                    </Typography>
                </Box>
            </Box>
        </Grid>
    );
};

export default TicketInfoChip;

const handleStatusColor = (variable: string | undefined, theme: any): string => {
    switch (variable) {
        case 'waiting':
        case 'pending':
        case 'medium':
            return theme.palette.warning.main;
        case 'answered':
            return theme.palette.success.main;
        case 'closed':
        case 'high':
            return theme.palette.error.main;
        case 'low':
            return theme.palette.text.secondary;
        case 'adminCreated':
            return theme.palette.mode === 'dark'
                ? theme.palette.info.light
                : theme.palette.info.main;
        case 'financial':
        case 'technical':
        case 'general':
        case 'info_change':
        case 'gateway_request':
        case 'authentication':
        case 'transaction_tracking':
        case 'merchant_violation':
        case 'legal':
        case 'comment':
            return theme.palette.mode === 'dark'
                ? theme.palette.primary.light
                : theme.palette.primary.main;
        default:
            return theme.palette.primary.main;
    }
};

const handleStatusLabel = (variable: string | undefined): string => {
    switch (variable) {
        case 'waiting':
            return 'در انتظار پاسخ';
        case 'pending':
            return 'درحال بررسی';
        case 'answered':
            return 'پاسخ داده شده';
        case 'closed':
            return 'بسته شده';
        case 'adminCreated':
            return 'تیکت جدید';
        case 'financial':
            return 'موارد مالی و مغایرت';
        case 'technical':
            return 'موارد فنی';
        case 'general':
            return 'عمومی';
        case 'info_change':
            return 'تایید یا تغییر اطلاعات';
        case 'gateway_request':
            return 'درخواست درگاه پرداخت';
        case 'authentication':
            return 'احراز هویت';
        case 'transaction_tracking':
            return 'پیگیری تراکنش';
        case 'merchant_violation':
            return 'گزارش تخلف پذیرنده';
        case 'legal':
            return 'حقوقی و پیگیری قضایی';
        case 'comment':
            return 'پیشنهاد، انتقاد و شکایت';
        case 'low':
            return 'معمولی';
        case 'medium':
            return 'مهم';
        case 'high':
            return 'بسیار مهم';
        default:
            return ' - ';
    }
};
